function readHeights() {
  const h = {};
  h.windowHeight = window.innerHeight;
  h.announcementHeight = getHeight('#shopify-section-announcement');
  h.footerHeight = getHeight('[data-section-type*="footer"]');
  h.menuHeight = getHeight('[data-header-height]');
  h.headerHeight = h.menuHeight + h.announcementHeight;
  h.logoHeight = getFooterLogoWithPadding();
  return h;
}

function setVarsOnResize() {
  document.addEventListener('theme:resize', resizeVars);
  setVars();
}

function setVars() {
  const {windowHeight, announcementHeight, headerHeight, logoHeight, menuHeight, footerHeight} = readHeights();
  document.documentElement.style.setProperty('--full-screen', `${windowHeight}px`);
  document.documentElement.style.setProperty('--three-quarters', `${windowHeight * 0.75}px`);
  document.documentElement.style.setProperty('--two-thirds', `${windowHeight * 0.66}px`);
  document.documentElement.style.setProperty('--one-half', `${windowHeight * 0.5}px`);
  document.documentElement.style.setProperty('--one-third', `${windowHeight * 0.33}px`);
  document.documentElement.style.setProperty('--one-fifth', `${windowHeight * 0.2}px`);
  document.documentElement.style.setProperty('--menu-height', `${menuHeight}px`);
  document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
  document.documentElement.style.setProperty('--content-full', `${windowHeight - headerHeight - logoHeight / 2}px`);
  document.documentElement.style.setProperty('--content-min', `${windowHeight - headerHeight - footerHeight}px`);

  document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
}

function resizeVars() {
  // restrict the heights that are changed on resize to avoid iOS jump when URL bar is shown and hidden
  const {windowHeight, announcementHeight, headerHeight, logoHeight, menuHeight, footerHeight} = readHeights();
  document.documentElement.style.setProperty('--menu-height', `${menuHeight}px`);
  document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
  document.documentElement.style.setProperty('--content-full', `${windowHeight - headerHeight - logoHeight / 2}px`);
  document.documentElement.style.setProperty('--content-min', `${windowHeight - headerHeight - footerHeight}px`);
}

function getHeight(selector) {
  const el = document.querySelector(selector);
  if (el) {
    return el.clientHeight;
  } else {
    return 0;
  }
}

function getFooterLogoWithPadding() {
  const height = getHeight('[data-footer-logo]');
  if (height > 0) {
    return height + 20;
  } else {
    return 0;
  }
}

export {setVarsOnResize, readHeights};
